"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolLocation = exports.SchoolLocationType = void 0;
var Base_1 = require("../Base");
var SchoolLocationType;
(function (SchoolLocationType) {
    SchoolLocationType[SchoolLocationType["Unknown"] = 0] = "Unknown";
    SchoolLocationType[SchoolLocationType["Building"] = 1] = "Building";
})(SchoolLocationType = exports.SchoolLocationType || (exports.SchoolLocationType = {}));
var SchoolLocation = /** @class */ (function (_super) {
    __extends(SchoolLocation, _super);
    function SchoolLocation() {
        var _this = _super.call(this) || this;
        _this.description = '';
        _this.name = '';
        _this.notes = '';
        _this.locationType = SchoolLocationType.Unknown;
        return _this;
    }
    SchoolLocation.getFriendlyLocationName = function (type) {
        return SchoolLocationType[type] || 'Unknown';
    };
    return SchoolLocation;
}(Base_1.BaseModel));
exports.SchoolLocation = SchoolLocation;
//# sourceMappingURL=Location.js.map